import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useHistory, matchPath } from 'react-router-dom';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';
import ContentItemWithImage from '../ContentItem/ContentItemImage/ContentItemImage';
import ContentItem from '../ContentItem/ContentItem/ContentItem';
import _ from 'lodash';

import './ContentCluster.scss';
import 'swiper/swiper-bundle.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/navigation/navigation.min.css';

SwiperCore.use([Pagination, Autoplay, Navigation]);

export default function ContentCluster({ data, preview }: { data: Record<string, any>, preview: boolean }) {
  const swiperRef = React.useRef<SwiperCore>();
  const clusters = preview ? [data.clusters[0].content_item] : data.contentItems;
  const history = useHistory();
  const onInit = (Swiper: SwiperCore): void => {
    swiperRef.current = Swiper;
  };
  const matchPage = matchPath(history.location.pathname, {
    path: ['/lotto', '/sports-betting/:type', '/racing/:type'],
    exact: true,
    strict: true
  });

  const renderCluster = () => (
    <Swiper
      onInit={ onInit }
      className="content-cluster"
      observeParents={ true }
      observer={ true }
      observeSlideChildren={ true }
      { ...data?.configuration }
    >
      {
        _.map(clusters, (contentItem, i) => (
          <SwiperSlide key={ `${ contentItem.title }${ i }` }>
            {
              contentItem.background ? (
                <ContentItemWithImage
                  item={ contentItem }
                  height={ data?.configuration?.contentheight }
                />)
                :
                <ContentItem item={ contentItem } />
            }
          </SwiperSlide>
        ))
      }
    </Swiper>
  );

  if (matchPage || preview) return renderCluster();

  return null;
}
